import { apiUtil } from 'lifesci-ui'

const { request } = apiUtil

function examBasePath() {
  return import.meta.env.VUE_APP_EXAM_BASE_API + import.meta.env.VUE_APP_EXAM_BASE_PATH
}

const EXAM_BASE_PATH_ADMIN = examBasePath() + import.meta.env.VUE_APP_EXAM_BASE_PATH_ADMIN

export function list(data) {
  return request({
    url: EXAM_BASE_PATH_ADMIN + '/subject/list',
    method: 'post',
    data
  })
}

export function pageList(data) {
  return request({
    url: EXAM_BASE_PATH_ADMIN + '/subject/page',
    method: 'post',
    data
  })
}

export function edit(data) {
  return request({
    url: EXAM_BASE_PATH_ADMIN + '/subject/edit',
    method: 'post',
    data
  })
}

export function select(id) {
  return request({
    url: EXAM_BASE_PATH_ADMIN + '/subject/select/' + id,
    method: 'post',
  })
}

export function deleteSubject(id) {
  return request({
    url: EXAM_BASE_PATH_ADMIN + '/subject/delete/' + id,
    method: 'post',
  })
}
